<template>
  <small>
    <a href="javascript:void(0)" @click.prevent="onDownloadFile">
      {{ title }}
    </a>
  </small>
</template>

<script>
export default {
  name: 'DownloadHelper',
  props: {
    fullUrl: {
      required: true,
      type: String,
    },
    validateFormat: {
      type: Boolean,
      default: true,
    },
    validFormats: {
      type: Array,
      default: () => ['text/csv', 'application/csv', 'application/vnd.ms-excel'],
    },
    title: {
      required: false,
      default: 'Download de Exemplo',
      type: String,
    },
  },
  methods: {
    async onDownloadFile() {
      try {
        const response = await fetch(this.fullUrl)

        if (!response.ok) throw new Error('Arquivo não encontrado no servidor')

        const blob = await response.blob()
        const isValid = this.validFormats.some(tipo => blob.type.includes(tipo))

        if (!isValid && this.validateFormat) {
          const errorMessage = 'O formato do arquivo retornado pelo servidor não é um formato válido.'
          console.warn('Tipo de arquivo rejeitado pelo sistema:', blob.type)
          this.$notify.error(errorMessage)
          throw new Error(errorMessage)
        }

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'atualizacao_participante.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Erro ao buscar o arquivo CSV:', error)
      }
    },
  },
}
</script>
